import type { RouteRecordRaw } from 'vue-router';

export const USER_LIST_ROUTER: RouteRecordRaw[] = [
  {
    path: '/admin/user',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/bom/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/admin/userList/views/UserList.vue'),
        name: 'User List',
        meta: {
          title: '사용자 관리',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/admin/userList/views/Detail.vue'),
        name: 'User Create',
        meta: {
          title: '사용자 등록',
        },
      },
    ],
  },
  {
    path: '/admin/user/detail/:no',
    component: () => import('@/modules/admin/userList/views/Detail.vue'),
    name: 'User Detail',
    meta: {
      title: '사용자 상세',
      requiresAuth: true,
    },
  },
];
